import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { setCurrentSaveFunction, clearCurrentSaveFunction, saveFunctionRegistry } from '../state/configurationSlice';

export const useConfigurationSave = (saveFunction: () => void) => {
    const dispatch = useDispatch();
    const functionIdRef = useRef<string>();

    useEffect(() => {
        // Generate a unique ID for this save function
        const functionId = `save_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        functionIdRef.current = functionId;
        
        // Register the function in the registry
        saveFunctionRegistry.register(functionId, saveFunction);
        
        // Store the ID in Redux state
        dispatch(setCurrentSaveFunction(functionId));
        
        // Cleanup function to unregister when component unmounts
        return () => {
            if (functionIdRef.current) {
                saveFunctionRegistry.unregister(functionIdRef.current);
                dispatch(clearCurrentSaveFunction());
            }
        };
    }, [saveFunction, dispatch]);
};
